// @flow

import React, { Component } from "react";
import Sidebar from "react-sidebar";
import { connect } from "react-redux";
// import {helper} from '../../utils/helpers/helper.js';
import { Icon, Button } from "tabler-react";
import { Loader, LoadingError, Box, FilterBox } from "../../component";
import { MapFilterComponent } from "./components";
import LeafletMapComponent from "./LeafletMap";
import { SidebarContainerStyle } from "./components/SidebarComponent/containerStyle.js";
import "./components/SidebarComponent/style.css";
import "./style.css";

import { mapActions, drawingActions, tickerActions } from "../../store/actions";

const mql = window.matchMedia(`(min-width: 800px)`);

class MapComponent extends Component {
  constructor(props) {
    super(props);
    this.state = {
      sidebarDocked: mql.matches,
    };

    this.mediaQueryChanged = this.mediaQueryChanged.bind(this);
    this.onSetSidebarOpen = this.onSetSidebarOpen.bind(this);
  }

  async componentDidMount() {
    await this.props.loadMapData();
    await this.props.getFilterMetaResults();
    await this.props.getTickerData();

    //ACCESS TO ADMIN AND USER LEVEL 2
    let localStorageSubscription = JSON.parse(
      localStorage.getItem("subscription_details")
    );
    if (
      localStorageSubscription?.subscription_level === null ||
      localStorageSubscription?.subscription_level === 2
    ) {
      await this.props.recievePolycoord();
    }

    mql.addListener(this.mediaQueryChanged);
  }

  componentWillUnmount() {
    // this.state.mql.removeListener(this.mediaQueryChanged);
  }

  onSetSidebarOpen = () => {
    const { sidebarOpen, showFilters } = this.props;
    const filterVal =
      showFilters === false && sidebarOpen === true ? null : showFilters;
    const sidebarVal =
      showFilters === false && sidebarOpen === true ? null : sidebarOpen;
    this.props.openFilterSidebar(filterVal, sidebarVal);
  };

  mediaQueryChanged() {
    const { sidebarOpen } = this.props;
    this.props.openFilterSidebar(true, sidebarOpen);
    this.setState({ sidebarDocked: mql.matches });
  }

  handleChange = (date) => {
    this.setState({
      startDate: date,
    });
  };

  getShowFiltersState = (props) => {
    this.props.openFilterSidebar(props, null);
  };

  loadMore() {
    const props = this.props;
    props.getNextFilterResults(this.props.nextPage, this.props.recordCount);
  }

  showAllIncidents(e) {
    if (e.target) {
      this.props.openFilterSidebar(false, null);
    }
  }

  clearFilters(e) {
    if (e.target) {
      this.props.openFilterSidebar(true, null);
    }
  }

  handleSidebarBtn = (event) => {
    return (
      <>
        <Box data-tut="mapFilterBtn">
          <Button
            icon="sliders"
            id="mapFilterBtn"
            type="button"
            color="primary"
            className="mapFilterBtn"
            onClick={this.onSetSidebarOpen}
          >
            <span className="label">Search / Filters</span>
          </Button>
        </Box>
      </>
    );
  };

  render() {
    const {
      mapLoading,
      filter,
      filterDataError,
      filterMetaError,
      nextPage,
      showFilters,
      sidebarOpen,
      filterData,
    } = this.props;
    const SidebarBtn = this.handleSidebarBtn();
    return (
      <>
        <div className="text-left mb-4">
          <Sidebar
            styles={SidebarContainerStyle}
            sidebar={
              <>
                <div id="sidebarControls">
                  <div className="sidebar-back-btn float-left">
                    <button
                      className="btn btn-link"
                      onClick={
                        showFilters !== false
                          ? this.onSetSidebarOpen
                          : this.clearFilters.bind(this)
                      }
                    >
                      <Icon prefix="fe" name="arrow-left" />
                    </button>
                  </div>
                  {showFilters === false &&
                  nextPage !== null &&
                  filterData !== [] &&
                  filterDataError === null ? (
                    <div className="sidebar-next-btn float-right">
                      <button
                        className="btn btn-link"
                        onClick={this.loadMore.bind(this)}
                      >
                        <Icon prefix="fe" name="arrow-right" />
                      </button>
                    </div>
                  ) : (
                    ""
                  )}
                  <FilterBox data-tut="filter-layer">
                    {(showFilters === true &&
                      filter === false &&
                      filterDataError === null) ||
                    (showFilters === true &&
                      filter === true &&
                      filterDataError === null) ? (
                      <div className="sidebar-next-btn float-right">
                        <button
                          className="btn btn-link"
                          onClick={this.showAllIncidents.bind(this)}
                        >
                          <Icon prefix="fe" name="layers" />
                        </button>
                      </div>
                    ) : (
                      ""
                    )}
                  </FilterBox>
                </div>
                {filterMetaError !== null ? (
                  <LoadingError errorMsg={filterMetaError} />
                ) : (
                  ""
                )}
                <MapFilterComponent
                  get={this.getShowFiltersState}
                  show={showFilters}
                />
              </>
            }
            className="mb-4 mr-4"
            open={sidebarOpen}
            onSetOpen={this.onSetSidebarOpen}
          />
        </div>
        {mapLoading ? (
          <Loader image="map-spinner" />
        ) : (
          <>
            <LeafletMapComponent sidebarBtn={SidebarBtn} />
          </>
        )}
      </>
    );
  }
}

function mapStateToProps(state) {
  const { subscription } = state.user;
  const {
    filterData,
    filterDataError,
    filter,
    filterMetaError,
    mapLoading,
    nextPage,
    recordCount,
    showFilters,
    sidebarOpen,
  } = state.map;
  return {
    subscription,
    mapLoading,
    filter,
    filterDataError,
    filterMetaError,
    nextPage,
    showFilters,
    sidebarOpen,
    filterData,
    recordCount,
  };
}

const mapDispatchToProps = {
  getTickerData: tickerActions.getTickerNews,
  loadMapData: mapActions.loadMapData,
  getNextFilterResults: mapActions.getNextFilterResults,
  getFilterMetaResults: mapActions.getFilterMetaResults,
  openFilterSidebar: mapActions.openFilterSidebar,
  recievePolycoord: drawingActions.recievePolycoord,
};

export default connect(mapStateToProps, mapDispatchToProps)(MapComponent);
